import { IMPORTED_FILE_EXTENSIONS, CRS_REQUEST_STATUS_OBJ, SUPPLIER_NUMBER_CM_COLUMN, DEERE_PART_CM_COLUMN, SUPPLIER_NUMBER_EM_COLUMN, DEERE_PART_EM_COLUMN, SUPPLIER_COLUMN, PART_TPS_COLUMN, DESCRIPTION_TPS_COLUMN, HSCODE_TPS_COLUMN , SUPPLIER_NUMBER_COO_COLUMN, PART_COO_COLUMN, DESCRIPTION_COO_COLUMN, PART_SUPPLIER_NUMBER_COLUMN, PART_COLUMN, PART_DESCRIPTION_COLUMN, PART_SECTION_COLUMN, UNIT_CODE_COO_COLUMN, PART_FIRST_NAME_COLUMN, PART_LAST_NAME_COLUMN, PART_RACF_COLUMN, DEERE_ADDCOL1_IDX, DEERE_ADDCOL2_IDX, NONDEERE_ADDCOL1_IDX, NONDEERE_ADDCOL2_IDX } from './surveyLiterals'
import { NON_DEERE_SUPPLIER_NUMBER_COLUMN, NON_DEERE_SUPPLIER_NAME_COLUMN, NON_DEERE_PART_NUMBER_COLUMN, NON_DEERE_PART_DESCRIPTION_COLUMN, NON_DEERE_SUPPLIER_EMAIL_COLUMN, NON_DEERE_COMPANY_EMAIL_COLUMN } from './surveyLiterals'

export const getExention = (file) => {
  const parts = file.name.split('.')
  const extension = parts[parts.length - 1]
  return IMPORTED_FILE_EXTENSIONS.includes(extension)
}

export const convertToJson = (headers, data) => {
  const rows = []
  data.forEach((row, indx) => {
    let rowData = { id: indx }
    row.forEach((element, index) => {
      rowData[headers[index]] = element
    })
    rows.push(rowData)

  });
  rows.splice(0, 1);
  return rows
}

export const createCMAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
      const supplier = element[SUPPLIER_NUMBER_CM_COLUMN]? element[SUPPLIER_NUMBER_CM_COLUMN].toString():'';
      const part = element[DEERE_PART_CM_COLUMN]? element[DEERE_PART_CM_COLUMN].toString() : '';
      group[supplier] = group[supplier] ?? []
      group[supplier].push({
        deerePartNumber: part ? part.trim() : part,
        createdBy: userInfo.userID,
      })
      return group
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = []
      Object.keys(groupBy).forEach(key => {
        const supplierNumber = key ? key.toString().trim().padStart(10, '0') : key;
        assignments.push({
          supplierNumber: supplierNumber,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: groupBy[key]
        })
      })
      return assignments
    }
  }
}

export const createEMAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
      const supplier = element[SUPPLIER_NUMBER_EM_COLUMN]? element[SUPPLIER_NUMBER_EM_COLUMN].toString():'';
      const part = element[DEERE_PART_EM_COLUMN]? element[DEERE_PART_EM_COLUMN].toString() : '';
      group[supplier] = group[supplier] ?? []
      group[supplier].push({
        deerePartNumber: part ? part.trim() : part,
        createdBy: userInfo.userID,
      })
      return group
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = []
      Object.keys(groupBy).forEach(key => {
        const supplierNumber = key ? key.toString().trim().padStart(10, '0') : key;
        assignments.push({
          supplierNumber: supplierNumber,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: groupBy[key]
        })
      })
      return assignments
    }
  }
}

export function validateDuplicates(array,supplierCol,partCol, ...extraCols) {
  if (!Array.isArray(array)) {
    return []
  }
  const normalized = (v) => (v === null || v === undefined) ? '' : v.toString().trim().toLowerCase();
  const uniqIds = new Set();
  const duplicates = []
  array.forEach(element => {
    const supp = normalized(element[supplierCol]);
    const part = normalized(element[partCol]);
    const extras = extraCols.map(col => normalized(element[col]));
    const key = [supp, part, ...extras].join('|');
    const isDuplicate = uniqIds.has(key)
    if(isDuplicate){
      duplicates.push(element.id + 1)
    }
    else uniqIds.add(key)
  })
  return duplicates
}

export function validateNonDeereDuplicates(array,supplierCol,partCol, ...extraCols) {
  if (!Array.isArray(array)) {
    return []
  }
  const normalized = (v) => (v === null || v === undefined) ? '' : v.toString().trim().toLowerCase();
  const uniqIds = new Set();
  const duplicates = []
  array.forEach(element => {
    const supp = normalized(element[supplierCol]);
    const part = normalized(element[partCol]);
    const extras = extraCols.map(col => normalized(element[col]));
    const key = [supp, part, ...extras].join('|');
    const isDuplicate = uniqIds.has(key)
    if(isDuplicate){
      duplicates.push(element.id + 1)
    }
    else uniqIds.add(key)
  })
  return duplicates
}

export const validateEWDCDuplicates = (data) => {
  if (!Array.isArray(data)) {
    return []
  }
  const uniqIds = new Set();
  const duplicates = [];
  data.forEach((element) => {
    const supp = element[PART_SUPPLIER_NUMBER_COLUMN] ? element[PART_SUPPLIER_NUMBER_COLUMN].toString() : element[PART_SUPPLIER_NUMBER_COLUMN];
    const fName = element[PART_FIRST_NAME_COLUMN] ? element[PART_FIRST_NAME_COLUMN].toString() : element[PART_FIRST_NAME_COLUMN];
    const lName = element[PART_LAST_NAME_COLUMN] ? element[PART_LAST_NAME_COLUMN].toString() : element[PART_LAST_NAME_COLUMN];
    const racf = element[PART_RACF_COLUMN] ? element[PART_RACF_COLUMN].toString() : element[PART_RACF_COLUMN];
    const isDuplicate = uniqIds.has(supp + fName + lName + racf);
    if(isDuplicate){
      duplicates.push(element.id + 1)
    }
    else uniqIds.add(supp + fName + lName + racf)
  });
  return duplicates
}

export const validateSupplierPart = (data,colsToValidate) => {
  if (Array.isArray(data) && data.length > 0) {
    const errors = [];
    data.forEach((element) => {
      for(let i=0; i<colsToValidate.length; i++){
        if(!element[colsToValidate[i]]){
          errors.push(element.id + 1);
          break;
        }
      }
    })
    return errors;
  }
  return []
}

export const createTPSAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
    const supplier = element[SUPPLIER_COLUMN] ? element[SUPPLIER_COLUMN].toString() : '';
    const part = element[PART_TPS_COLUMN] ? element[PART_TPS_COLUMN].toString() : '';
    const partDescription = element[DESCRIPTION_TPS_COLUMN]? element[DESCRIPTION_TPS_COLUMN].toString() : '';
    const hsCode = element[HSCODE_TPS_COLUMN] ? element[HSCODE_TPS_COLUMN].toString() : '';
      
      group[supplier] = group[supplier] ?? []
      group[supplier].push({
        deerePartNumber: part ? part.trim() : part,
        deerePartDesc: partDescription.trim(),
        hsCode: hsCode.trim(),
        createdBy: userInfo.userID,
      })
      return group
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = []
      Object.keys(groupBy).forEach(key => {
        const supplierNumber = key ? key.toString().trim().padStart(10, '0') : key;
        assignments.push({
          supplierNumber: supplierNumber,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: groupBy[key]
        })
      })
      return assignments
    }
  }
}

export const createSurveyAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
      const supplier = element[PART_SUPPLIER_NUMBER_COLUMN] ? element[PART_SUPPLIER_NUMBER_COLUMN].toString() : '';
      const part = element[PART_COLUMN] ? element[PART_COLUMN].toString() : '';
      const partDescription = element[PART_DESCRIPTION_COLUMN]? element[PART_DESCRIPTION_COLUMN].toString() : '';
      const keys = Object.keys(element);
      const additionalColumn1Header = keys[DEERE_ADDCOL1_IDX] ? keys[DEERE_ADDCOL1_IDX].toString() : '';
      const additionalColumn2Header = keys[DEERE_ADDCOL2_IDX] ? keys[DEERE_ADDCOL2_IDX].toString() : '';
      const section = element[PART_SECTION_COLUMN] ? element[PART_SECTION_COLUMN].toString() : '';
      group[supplier] = group[supplier] ?? []

      const supplierObj = {
        deerePartNumber: part ? part.trim() : part,
        deerePartDesc: partDescription.trim(),
        additionalColumn1: additionalColumn1Header ? element[additionalColumn1Header].toString().trim() : '',
        additionalColumn2: additionalColumn2Header ? element[additionalColumn2Header].toString().trim() : '',
        section: section.trim(),
        createdBy: userInfo.userID,
      }

      group[supplier].push(supplierObj);
      
      return group
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = []
      Object.keys(groupBy).forEach(key => {
        const supplierNumber = key ? key.toString().trim().padStart(10, '0') : key;
        assignments.push({
          supplierNumber: supplierNumber,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: groupBy[key]
        })
      })
      return assignments
    }
  }
}

export const createEWDCAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
      const supplier = element[PART_SUPPLIER_NUMBER_COLUMN] ? element[PART_SUPPLIER_NUMBER_COLUMN].toString() : '';
      const fName = element[PART_FIRST_NAME_COLUMN] ? element[PART_FIRST_NAME_COLUMN].toString() : '';
      const lName = element[PART_LAST_NAME_COLUMN]? element[PART_LAST_NAME_COLUMN].toString() : '';
      const racf = element[PART_RACF_COLUMN] ? element[PART_RACF_COLUMN].toString() : '';
      
      group[supplier] = group[supplier] ?? []
      
      group[supplier].push({
        deerePartNumber: fName ? fName.trim() : fName,
        deerePartDesc: lName ? lName.trim() : lName,
        hsCode: racf ? racf.trim() : racf,
        section: "",
        createdBy: userInfo.userID,
      })
      
      return group
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = []
      Object.keys(groupBy).forEach(key => {
        const supplierNumber = key ? key.toString().trim().padStart(10, '0') : key;
        assignments.push({
          supplierNumber: supplierNumber,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: groupBy[key]
        })
      })
      return assignments
    }
  }
};

export const createCOOAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
    const supplier = element[SUPPLIER_NUMBER_COO_COLUMN] ? element[SUPPLIER_NUMBER_COO_COLUMN].toString() : '';
    const part = element[PART_COO_COLUMN] ? element[PART_COO_COLUMN].toString() : '';
    const partDescription = element[DESCRIPTION_COO_COLUMN]? element[DESCRIPTION_COO_COLUMN].toString() : '';
    const unitCd = element[UNIT_CODE_COO_COLUMN]? element[UNIT_CODE_COO_COLUMN].toString() : '';
      
      group[supplier] = group[supplier] ?? []
      group[supplier].push({
        deerePartNumber: part ? part.trim() : part,
        deerePartDesc: partDescription.trim(),
        unitCd: unitCd.trim(),
        createdBy: userInfo.userID,
      })
      return group
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = []
      Object.keys(groupBy).forEach(key => {
        const supplierNumber = key ? key.toString().trim().padStart(10, '0') : key;
        assignments.push({
          supplierNumber: supplierNumber,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: groupBy[key]
        })
      })
      return assignments
    }
  }
}

export const createNonDeereAssignments = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
      const supplierNumber = element[NON_DEERE_SUPPLIER_NUMBER_COLUMN] ? element[NON_DEERE_SUPPLIER_NUMBER_COLUMN].toString() : "";
      const supplierName = element[NON_DEERE_SUPPLIER_NAME_COLUMN] ? element[NON_DEERE_SUPPLIER_NAME_COLUMN].toString() : "";
      const partNumber = element[NON_DEERE_PART_NUMBER_COLUMN] ? element[NON_DEERE_PART_NUMBER_COLUMN].toString() : "";
      const partDescription = element[NON_DEERE_PART_DESCRIPTION_COLUMN] ? element[NON_DEERE_PART_DESCRIPTION_COLUMN].toString() : "";
      const supplierContactEmail = element[NON_DEERE_SUPPLIER_EMAIL_COLUMN] ? element[NON_DEERE_SUPPLIER_EMAIL_COLUMN].toString() : "";
      const companyContactEmail = element[NON_DEERE_COMPANY_EMAIL_COLUMN] ? element[NON_DEERE_COMPANY_EMAIL_COLUMN].toString() : "";
      const keys = Object.keys(element);
      const additionalColumn1Header = keys[NONDEERE_ADDCOL1_IDX] ? keys[NONDEERE_ADDCOL1_IDX].toString() : '';
      const additionalColumn2Header = keys[NONDEERE_ADDCOL2_IDX] ? keys[NONDEERE_ADDCOL2_IDX].toString() : '';
      const section = element[PART_SECTION_COLUMN] ? element[PART_SECTION_COLUMN].toString() : '';
      group[`${supplierNumber}__${supplierName}`] = group[`${supplierNumber}__${supplierName}`] ?? [];
      group[`${supplierNumber}__${supplierName}`].push({
        deerePartNumber: partNumber ? partNumber.trim() : partNumber,
        deerePartDesc: partDescription.trim(),
        supplierContactEmail: supplierContactEmail.trim(),
        companyContactEmail: companyContactEmail.trim(),
        createdBy: userInfo.userID,
        additionalColumn1: additionalColumn1Header ? element[additionalColumn1Header].toString().trim() : '',
        additionalColumn2: additionalColumn2Header ? element[additionalColumn2Header].toString().trim() : '',
        section: section.trim(),
      });
      return group;
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = [];
      Object.keys(groupBy).forEach((key) => {
        const supplierNumber = key ? key.split("__")[0].toString().trim().padStart(10, "0") : key;
        const supplierName = key ? key.split("__")[1].toString().trim() : key;
        const part = [];
        const deerePartDesc = [];
        groupBy[key].forEach((obj) => {
          part.push({ deerePartNumber: obj.deerePartNumber, deerePartDesc: obj.deerePartDesc, createdBy: obj.createdBy, additionalColumn1: obj.additionalColumn1, additionalColumn2: obj.additionalColumn2, section: obj.section });
          let suppContactIndex = deerePartDesc.findIndex((dpd) => dpd.contactEmail === obj.supplierContactEmail);
          if (suppContactIndex === -1) deerePartDesc.push({ contactEmail: obj.supplierContactEmail, isCompanyContact: false, createdBy: obj.createdBy });
          let companyContactIndex = deerePartDesc.findIndex((dpd) => dpd.contactEmail === obj.companyContactEmail);
          if (companyContactIndex === -1) deerePartDesc.push({ contactEmail: obj.companyContactEmail, isCompanyContact: true, createdBy: obj.createdBy });
        });
        assignments.push({
          supplierNumber: supplierNumber,
          supplierName: supplierName,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: part,
          nonDeereContact: deerePartDesc,
        });
      });
      return assignments;
    }
  }
};

export const createCMAssignmentsNonDeere = (data, userInfo) => {
  if (Array.isArray(data) && data.length > 0) {
    const groupBy = data.reduce((group, element) => {
      const supplierNumber = element[NON_DEERE_SUPPLIER_NUMBER_COLUMN] ? element[NON_DEERE_SUPPLIER_NUMBER_COLUMN].toString() : "";
      const supplierName = element[NON_DEERE_SUPPLIER_NAME_COLUMN] ? element[NON_DEERE_SUPPLIER_NAME_COLUMN].toString() : "";
      const partNumber = element[NON_DEERE_PART_NUMBER_COLUMN] ? element[NON_DEERE_PART_NUMBER_COLUMN].toString() : "";
      const partDescription = element[NON_DEERE_PART_DESCRIPTION_COLUMN] ? element[NON_DEERE_PART_DESCRIPTION_COLUMN].toString() : "";
      const supplierContactEmail = element[NON_DEERE_SUPPLIER_EMAIL_COLUMN] ? element[NON_DEERE_SUPPLIER_EMAIL_COLUMN].toString() : "";
      const companyContactEmail = element[NON_DEERE_COMPANY_EMAIL_COLUMN] ? element[NON_DEERE_COMPANY_EMAIL_COLUMN].toString() : "";
      group[`${supplierNumber}__${supplierName}`] = group[`${supplierNumber}__${supplierName}`] ?? [];
      group[`${supplierNumber}__${supplierName}`].push({
        partNumber: partNumber ? partNumber.trim() : partNumber,
        partDesc: partDescription ? partDescription.trim() : partDescription,
        supplierContactEmail: supplierContactEmail ? supplierContactEmail.trim() : supplierContactEmail,
        companyContactEmail: companyContactEmail ? companyContactEmail.trim() : companyContactEmail,
        createdBy: userInfo.userID,
      });
      return group;
    }, {});

    if (groupBy !== undefined && groupBy !== null) {
      const assignments = [];
      Object.keys(groupBy).forEach((key) => {
        const supplierNumber = key ? key.split("__")[0].toString().trim().padStart(10, "0") : key;
        const supplierName = key ? key.split("__")[1].toString().trim() : key;
        const part = [];
        const arrContacts = [];
        groupBy[key].forEach((obj) => {
          part.push({ partNumber: obj.partNumber, partDesc: obj.partDesc, createdBy: obj.createdBy });
          let suppContactIndex = arrContacts.findIndex((dpd) => dpd.contactEmail === obj.supplierContactEmail);
          if (suppContactIndex === -1) arrContacts.push({ contactEmail: obj.supplierContactEmail, isCompanyContact: false, createdBy: obj.createdBy });
          let companyContactIndex = arrContacts.findIndex((dpd) => dpd.contactEmail === obj.companyContactEmail);
          if (companyContactIndex === -1) arrContacts.push({ contactEmail: obj.companyContactEmail, isCompanyContact: true, createdBy: obj.createdBy });
        });
        assignments.push({
          supplierNumber: supplierNumber,
          supplierName: supplierName,
          active: true,
          createdBy: userInfo.userID,
          status: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING,
          part: part,
          nonDeereContact: arrContacts,
        });
      });
      return assignments;
    }
  }
};